'use client';

import TargetIconSvg from '@/assets/svgs/target.svg';

import { selectTrackedLinks } from '@/containers/Jobs/redux/jobEditors.selectors';
import { Modals } from '@/containers/Modals/all-modals';
import classNames from 'classnames';
import { useRef } from 'react';
import { useSelector } from 'react-redux';
import ModalBody from '../ModalBody';
import ModalHeader from '../ModalHeader';
import { ModalProps, ViewTrackedLinksModalParams } from '../types';
import useModals from '../useModals';

import AddTrackedLinkForm from '@/containers/TrackedLinks/AddTrackedLinkForm';
import ModalContainer from '../ModalContainer';
import TrackedLinksList from '../ViewTrackedLinksModal/TrackedLinksList';

export interface AddTrackingLinkFormValues {
  is_custom_slash_tag_link: boolean;
  destination_url: string;
  domain_id: string;
  domain_name: string;
  slash_tag?: string;
}

const modalName = Modals.AddTrackedLinkModal;

interface AddTrackedLinkModalProps extends ModalProps {
  className?: string;
  params?: ViewTrackedLinksModalParams;
}

const AddTrackedLinkModal = ({
  className,
  variant = 'default',
  params,
}: AddTrackedLinkModalProps) => {
  const modalBodyRef = useRef<HTMLDivElement>(null);
  const { isModalOpen, onClose } = useModals({
    modalName,
  });

  const jobId = params?.jobId || '';
  const trackedLinks = useSelector(selectTrackedLinks(jobId));

  return (
    <div className={classNames('relative', className)}>
      <input
        type="checkbox"
        id={modalName}
        className="modal-toggle"
        checked={isModalOpen}
        onChange={() => {}}
      />

      <ModalContainer
        isModalOpen={isModalOpen}
        modalName={modalName}
        variant={variant}
        onClose={onClose}>
        <div className="flex h-full flex-col">
          <ModalHeader
            modalName={modalName}
            icon={<TargetIconSvg className="h-5 w-5" />}
            title={trackedLinks.length > 0 ? 'Tracked Links' : 'Add a Tracked Link'}
          />

          <ModalBody ref={modalBodyRef} className="px-5 !py-0">
            <div className="h-6" />
            <AddTrackedLinkForm postSubmit={onClose} jobId={jobId} />
            {trackedLinks.length > 0 && (
              <div className="mt-2 mb-4">
                <div className="text-base-content mb-2 border-t border-gray-200 pt-4 text-sm font-medium dark:border-gray-800">
                  Existing Tracked Links ({trackedLinks.length})
                </div>
                <TrackedLinksList
                  jobId={jobId}
                  links={trackedLinks}
                  allowInsertion
                  hideAddButton
                  onInsert={onClose}
                  size="sm"
                />
              </div>
            )}
          </ModalBody>
        </div>
      </ModalContainer>
    </div>
  );
};

export default AddTrackedLinkModal;
